import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { GET_TIMESHEET_DETAILS } from "src/api-setup/api-endpoints";

export const getTimesheetDetails = async (cookiesData, dispatch, timesheetMstrKey) => {
  if (!cookiesData || !timesheetMstrKey) return null;

  try {
    const apiHeaders = generateHeader();

    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_timesheet_mstr_key: timesheetMstrKey,
      in_user_key: cookiesData.out_user_id,
      in_user_type: "ADMIN",
      in_filter: null,
      in_sort_number: 1,
      in_sort_order: "ASC",
    };

    const response = await POSTAPI(false, GET_TIMESHEET_DETAILS, null, apiHeaders, requestBody, dispatch);

    if (response && response.data && response.data.row_result) {
      const rowResult = response.data.row_result;
      // If row_result is an array, return the first element, otherwise return as is
      return Array.isArray(rowResult) && rowResult.length > 0 ? rowResult[0] : rowResult;
    }

    return null;
  } catch (error) {
    console.error("Error fetching timesheet details:", error);
    return null;
  }
};
